import { createFileRoute } from '@tanstack/react-router'
import { BillingPanel } from '../components/platform/SettingsPanels.tsx'

export const Route = createFileRoute('/_authed/_shell/settings/billing')({
  component: BillingPanel,
})
